import React from 'react';
export function ProductReveal() {
  return <section className="px-4 mb-12" data-id="element-126">
      <div className="bg-card rounded-2xl p-6 md:p-8 shadow-diary border border-brown/5 flex flex-col md:flex-row gap-6 items-center" data-id="element-127">
        <div className="w-full md:w-1/2 rounded-xl overflow-hidden" data-id="element-128">
          <img src="https://cdn.magicpatterns.com/uploads/rmYDenFQkTCcqoezHjgkCw/Magen_Darm_4f46689c-206a-426f-9344-0505df3c965a.webp" alt="Hunderunde Futtertopping Magen & Darm Verpackung" className="w-full h-auto object-contain" data-id="element-129" />
        </div>
        <div className="w-full md:w-1/2" data-id="element-130">
          <h3 className="font-handwriting text-3xl font-bold text-forest mb-4" data-id="element-131">
            Was ich bestellt habe
          </h3>
          <p className="font-serif text-text/90 leading-relaxed mb-4" data-id="element-132">
            Ich habe mich für das Magen-Darm Topping von Hunderunde entschieden,
            weil es zu <strong data-id="element-133">100% natürlich</strong> ist und genau die
            Präbiotika enthält, die Tonys Darmflora gefehlt haben.
          </p>
          <p className="font-serif text-text/90 leading-relaxed" data-id="element-134">
            Es war die <strong data-id="element-135">sanfteste Lösung</strong> ohne chemische Zusätze,
            um seine träge Verdauung wieder in Schwung zu bringen.
          </p>
        </div>
      </div>
    </section>;
}